// @flow
import { number, object } from 'yup';
import { getMonthName } from '@components/cluster/cluster-input-table/utils';

const getSPFlinkPoolValidationSchema = (maxLimit) =>
  object({
    cfu_count: number().min(0).max(maxLimit).label('This field').typeError('Required Field'),
  });

export const getSPFlinkMonthlyInputsValidation = (numberOfMonths, maxLimitsObject) => {
  const schemaObject = {};
  for (let i = 1; i <= numberOfMonths; i++) {
    schemaObject[getMonthName(i)] = getSPFlinkPoolValidationSchema(maxLimitsObject.cfu_count);
  }
  return object({ months: object(schemaObject) });
};
